import ReservationShadow from './iot/ReservationShadow';
import { ReservationProtocol } from './types';
import { getCurrentUserIdentityId } from '../../frontend-common-libs/src/utils/authUtils';
import createCpcrJob, { deleteCpcrJob, getCpcrJobProtocol } from './api/jobs';

export default class Job {
  private static async createInShadowWithProtocol(
    instrumentId: string,
    jobId: string
  ): Promise<void> {
    await new ReservationShadow().updateJob(instrumentId, jobId);
  }

  private static async bulkCreateInDbWithProtocol(
    reservationProtocolArray: ReservationProtocol[],
    entityId: string
  ) {
    const updatedReservationProtocolArray = reservationProtocolArray;
    const userId: string = getCurrentUserIdentityId();
    await Promise.all(
      reservationProtocolArray.map(async (reservation, index) => {
        try {
          const response = await createCpcrJob(userId, reservation.instrumentId, entityId);
          const { data, status } = response;
          const { jobId } = data;
          if (status === 200) {
            updatedReservationProtocolArray[index] = { ...reservation, jobId };
          }
        } catch (error) {
          console.log(
            `Error creating job for instrument ${reservation.instrumentId} and protocolId ${entityId} for user ${userId}, error is ${error}`
          );
        }
      })
    );
    return updatedReservationProtocolArray;
  }

  public static async bulkCreateWithProtocol(
    reservationProtocolArray: ReservationProtocol[],
    protocolId: string
  ): Promise<ReservationProtocol[]> {
    const updatedReservationProtocolArray = await Job.bulkCreateInDbWithProtocol(
      reservationProtocolArray,
      protocolId
    );

    const promises: Promise<void>[] = [];
    updatedReservationProtocolArray.forEach(selectedReservation => {
      promises.push(
        Job.createInShadowWithProtocol(selectedReservation.instrumentId, selectedReservation.jobId)
      );
    });
    await Promise.all(promises);

    return updatedReservationProtocolArray;
  }

  public static async bulkDeleteJob(
    selectedReservationProtocols: ReservationProtocol[]
  ): Promise<void> {
    const promises: Promise<void>[] = [];

    selectedReservationProtocols.forEach(reservationProtocol => {
      promises.push(Job.deleteJob(reservationProtocol.instrumentId, reservationProtocol.jobId));
    });

    await Promise.all(promises);
  }

  public static async deleteJob(instrumentId: string, jobId: string | null): Promise<void> {
    if (jobId === null) {
      return;
    }
    const userId: string = getCurrentUserIdentityId();
    try {
      const response = await deleteCpcrJob(userId, jobId);
      const { status } = response;
      if (status === 200) {
        await Job.deleteInShadow(instrumentId);
        return;
      }
    } catch (error) {
      console.log(`Error deleting job ${jobId} for user ${userId}, error is ${error}`);
    }
  }

  private static async deleteInShadow(instrumentId: string): Promise<void> {
    await new ReservationShadow().updateJob(instrumentId, null);
  }

  public static async getJobProtocolFromReservation(jobId: string | null): Promise<string | null> {
    if (jobId === null) {
      return null;
    }
    const userId: string = getCurrentUserIdentityId();

    try {
      const response = await getCpcrJobProtocol(userId, jobId);
      const { data, status } = response;
      if (status === 200) {
        return data.protocolName;
      }
    } catch (error) {
      console.log(
        `Error fetching protocol from job ${jobId} for user ${userId}, error is ${error}`
      );
    }

    return null;
  }
}
